<template>
  <div class="page-container has-action">
    <van-nav-bar
      title="天安金交中心收银台"
      fixed
      left-arrow
      @click-left="goableBack()"
    ></van-nav-bar>
    <div class="page">
      <div class="ta-c fs-32 mt-20">
        ¥{{ numFormat2(order.payAmount, '0.00') }}
      </div>

      <van-radio-group class="mt-50" v-model="radio">
        <van-cell title="微信支付" clickable @click="radio = '1'">
          <svg slot="icon" class="icon mr-30" aria-hidden="true">
            <use xlink:href="#icon-weixinzhifu"></use>
          </svg>
          <van-radio slot="right-icon" name="1" />
        </van-cell>
      </van-radio-group>
    </div>
    <div class="page-action px-20">
      <van-button
        class="btn-submit"
        size="large"
        round
        type="danger"
        @click="onPay"
        >确认付款</van-button
      >
    </div>
    <van-popup class="pay-dialog" v-model="payDialogShow">
      <div class="ta-c mt-10 py-20 fs-16"><b>请确认支付是否已完成</b></div>
      <van-button
        @click="onCheckPay"
        type="danger"
        size="large"
        plain
        square
        block
        ><b>支付完成</b></van-button
      >
      <van-button @click="onPay" type="info" size="large" plain square block
        >支付遇到问题,重新支付</van-button
      >
    </van-popup>
  </div>
</template>

<script>
import {
  Cell,
  NavBar,
  Stepper,
  Button,
  Toast,
  RadioGroup,
  Radio,
  Popup,
  Dialog,
} from 'vant'
import { mapGetters } from 'vuex'
import * as GoodsApi from '@/api/goods'
import Url from 'url'
export default {
  name: 'pay',
  data: () => ({
    code: '', //微信授权code
    order: {},
    radio: '1',
    payDialogShow: false,
    payData: null,
  }),
  beforeRouteEnter(to, form, next) {
    //支付之前先请求微信授权code
    let url = Url.parse(location.href, true)
    if (url.query.code && url.query.code.length > 10) {
      GoodsApi.getOrder(to.params.id)
        .then((data) => {
          next((vm) => {
            vm.setData(url.query.code, data)
          })
        })
        .catch((e) => {})
    } else {
      //获取微信授权code
      let redirect_uri = encodeURIComponent(
        process.env.VUE_APP_BASE_URL + '#' + to.fullPath
      )
      let href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxac4c97b0d165708e&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`
      location.href = href
    }
  },
  beforeRouteUpdate(to, from, next) {
    //支付之前先请求微信授权code
    let url = Url.parse(location.href, true)
    if (url.query.code && url.query.code.length > 10) {
      GoodsApi.getOrder(to.params.id)
        .then((data) => {
          next((vm) => {
            vm.setData(url.query.code, data)
          })
        })
        .catch((e) => {})
    } else {
      //获取微信授权code
      let redirect_uri = encodeURIComponent(
        process.env.VUE_APP_BASE_URL + '#' + to.fullPath
      )
      let href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxac4c97b0d165708e&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`
      location.href = href
    }
  },
  methods: {
    setData(code, data) {
      this.order = data
      this.code = code
      GoodsApi.saveInfo(this.code)
    },
    onPay() {
      if (this.os == 'wx' || this.os == 'mini') {
        if (this.payData) {
          this.bindWeixinJSBridge()
        } else {
          GoodsApi.pay(this.order.id, true, this.code)
            .then((data) => {
              data.package = data.packageValue
              this.payData = data
              this.bindWeixinJSBridge()
            })
            .catch((e) => {
              console.info(e)
            })
        }
      } else {
        GoodsApi.pay(this.order.id, false, null)
          .then((data) => {
            console.info(data)
          })
          .catch((e) => {
            console.info(e)
          })
      }
    },
    onCheckPay() {
      GoodsApi.queryOrder(this.order.id).then((data) => {
        if (data) {
          this.$router.replace({
            name: 'shop-pay-success',
            params: { id: this.order.id },
          })
        } else {
          this.payDialogShow = false
          this.showPayConfirm()
        }
      })
    },
    bindWeixinJSBridge() {
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            this.jsApiCall,
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.jsApiCall)
          document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall)
        }
      } else {
        this.jsApiCall()
      }
    },
    jsApiCall() {
      WeixinJSBridge.invoke('getBrandWCPayRequest', this.payData, (res) => {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          this.payDialogShow = true
        } else {
          this.showPayConfirm()
        }
      })
    },
    showPayConfirm() {
      Dialog.confirm({
        title: '支付失败',
        message: '如未完成支付请重新支付',
        confirmButtonText: '继续支付',
        cancelButtonText: '好的',
      })
        .then(() => {
          this.onPay()
        })
        .catch(() => {
          this.$router.replace({
            name: 'shop-order-view',
            params: { id: this.order.id },
          })
        })
    },
  },
  computed: {
    ...mapGetters(['os']),
  },
  components: {
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    [Stepper.name]: Stepper,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
  },
}
</script>

<style lang="less" scoped>
.page-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;
  box-sizing: border-box;
  background: #fff;
}
.icon {
  width: 36px;
  height: 36px;
  vertical-align: -0.15rem;
  fill: currentColor;
  overflow: hidden;
}
.van-cell {
  line-height: 36px;
}
.pay-dialog {
  box-sizing: border-box;
  width: 80%;
  border-radius: 5px;
  .van-button {
    border: none;
    border-top: 1px solid @gray;
  }
}
</style>
